import ProvisionalReceiptCancel from './ProvisionalReceiptCancel';

export default ProvisionalReceiptCancel;